export const INJECT_APP = Symbol("blokkli_app");
export const INJECT_EDIT_CONTEXT = Symbol("blokkli_edit_context");
export const INJECT_IS_EDITING = Symbol("blokkli_is_editing");
export const INJECT_IS_NESTED = Symbol("blokkli_is_nested");
export const INJECT_NESTING_LEVEL = Symbol("blokkli_nesting_level");
export const INJECT_IS_PREVIEW = Symbol("blokkli_is_preview");
export const INJECT_IS_IN_REUSABLE = Symbol("blokkli_is_in_reusable");
export const INJECT_REUSABLE_OPTIONS = Symbol("blokkli_from_library_options");
export const INJECT_FIELD_LIST_TYPE = Symbol("blokkli_field_list_type");
export const INJECT_FIELD_LIST_BLOCKS = Symbol("blokkli_field_list_blocks");
export const INJECT_FIELD_PROXY_MODE = Symbol("blokkli_field_proxy_mode");
export const INJECT_FIELD_USES_PROXY = Symbol("blokkli_field_uses_proxy");
export const INJECT_GLOBAL_PROXY_MODE = Symbol("blokkli_global_proxy_mode");
export const INJECT_PROVIDER_BLOCKS = Symbol("blokkli_provider_blocks");
export const INJECT_BLOCK_ITEM = Symbol("blokkli_block_item");
export const INJECT_MUTATED_FIELDS_MAP = Symbol("blokkli_mutated_fields_map");
export const INJECT_ENTITY_CONTEXT = Symbol("blokkli_entity_context");
export const INJECT_PROVIDER_CONTEXT = Symbol("blokkli_provider_context");
export const INJECT_FRAGMENT_CONTEXT = Symbol("blokkli_fragment_context");
export const INJECT_EDIT_FIELD_LIST_COMPONENT = Symbol(
  "blokkli_edit_field_list_component"
);
export const INJECT_EDIT_LOGGER = Symbol("blokkli_edit_logger");
export const BK_HIDDEN_GLOBALLY = "bkHiddenGlobally";
export const BK_VISIBLE_LANGUAGES = "bkVisibleLanguages";
